import React, { useEffect } from "react";
import { Header } from "../../internal/Header/Header";
import Footer from "../NewLandingPage/components/Footer";
import { Helmet } from "react-helmet";
import { Hero } from "../Resources/Webinar";
import { Images } from "../../../assets/images";
import {
  PageContainer,
  ContentSection,
  ClauseCard,
  ClauseList,
  ClausePoint,
  HeroTitle,
} from "../Resources/ModelClauses";
import { HyperLink } from "../../common/FormInputs";

function ArbitrationClauseRules(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const clauses = [
    {
      title: "IAMC Model Arbitration Clause",
      points: [
        <>
          In the event of any dispute arising out of or in connection with
          anything contained in the Agreement [or otherwise], the parties shall
          refer the dispute for{" "}
          <HyperLink
            onClick={() =>
              window.open(`https://user.iamch.org.in/arbitration-model-clause`)
            }
          >
            {" "}
            arbitration
          </HyperLink>{" "}
          through IAMC [www.justact.co.in] ("Institution").
        </>,
        "The parties may use any other ADR institution provided such Institution is agreed mutually by the parties.",
        "The arbitration shall be in accordance with the Arbitration and Conciliation Act, 1996 or any statutory modification or re-enactment thereof. The seat of arbitration shall be Chennai, India and language of the proceeding shall be English. The award of the Arbitrator shall be final and binding on the Parties. The arbitration may be conducted online.",
        "The Institution shall, among other things, appoint neutral Arbitrator(s) and provide a platform for resolution of the dispute between the parties as per the arbitration Rules of the Institution.",
        "Should this clause create a contradiction with a statutory requirement or a judicial mandate to resolve certain types of disputes through specific courts, the statutory requirement shall prevail.",
      ],
    },
  ];

  return (
    <>
      <Helmet>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <title>
          Arbitration Model Clause Rules - Arbitration Mediation and
          Conciliation - Arbitration Dispute Resolution
        </title>
        <meta
          name="description"
          content="Learn about the IAMC Arbitration & Conciliation Model Clause."
        />
        <meta
          name="keywords"
          content="Arbitration Model Clause Rules, Arbitration Dispute Resolution, Arbitration and Conciliation Rules, Arbitration Mediation and Conciliation, Online Dispute Resolution, Arbitration and Conciliation Rules Model Clauses, IAMC"
        />
      </Helmet>
      <div>
        <Header>
          <PageContainer>
            <Hero bgImage={Images.modalClause}>
              <HeroTitle>Arbitration Model Clause</HeroTitle>
            </Hero>
            <ContentSection>
              {clauses.map((clause, index) => (
                <ClauseCard key={index}>
                  <ClauseList>
                    {clause.points.map((point, pointIndex) => (
                      <ClausePoint key={pointIndex}>{point}</ClausePoint>
                    ))}
                  </ClauseList>
                </ClauseCard>
              ))}
            </ContentSection>
          </PageContainer>
        </Header>
        <Footer />
      </div>
    </>
  );
}

export default ArbitrationClauseRules;
